import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const ItemPickerStyles = styled.div`
  border: solid 1px ${Colors.accent.grey3.standard};
  border-radius: 2px;
  margin-top: 20px;

  input {
    display: none;
  }

  .horizontal {
    .radio-button {
      border-right: solid 1px ${Colors.accent.grey3.standard};
      cursor: pointer;
      margin-right: 0;
      width: 100%;

      &:last-child {
        border-right: none;
      }
      &:hover {
        background-color: ${Colors.primary.claytonBlue.tint};
        cursor: pointer;
      }
      label {
        cursor: pointer;
        justify-content: center;
        margin: 0;
        padding: 20px 0;
        width: 100%;

        &:focus {
          background-color: ${Colors.primary.claytonBlue.tint};
        }
      }
      &.selected {
        background-color: ${Colors.primary.claytonBlue.standard};

        label,
        label:focus {
          background-color: ${Colors.primary.claytonBlue.standard};
          color: #ffffff;
        }
      }
    }
  }
`;
